import type { ParsedFilterData } from '@autobid/strapi-integration/server/trpc/routers/auctions/auctionsFilter'

export function useDesignationDisplayValue() {
  const filterData = inject('filterData') as Ref<ParsedFilterData>

  return (des: unknown) => {
    if (!Array.isArray(des)) {
      return
    }
    if (!des.length) {
      return
    }

    return des.map(
      item =>
        filterData.value.designations.find(
          designation => designation.id === item,
        )?.label,
    ).filter(el => el !== undefined)
  }
}
